// Free shipping message start
const freeShippingMessage = () => {
    const el = document.querySelector('[data-limit-free-shipping]')
    if (!el) return

    const limit = parseFloat(el.dataset.limitFreeShipping) * 100
    const amountLeft = el.querySelector('[data-amount-left]')
    const no = el.querySelector('.cart__item--free-shipping-no')
    const yes = el.querySelector('.cart__item--free-shipping-yes')

    const formatMoney = (cents) => {
        const dollars = cents / 100
        return dollars % 1 === 0
        ? `$${dollars}`
        : `$${dollars.toFixed(2)}`
    }

    const update = (cartTotal) => {
        const remaining = limit - cartTotal

        if (remaining <= 0) {
        no.style.display = 'none'
        yes.style.display = ''
        } else {
        no.style.display = ''
        yes.style.display = 'none'
        amountLeft.textContent = formatMoney(remaining)
        }
    }

    fetch('/cart.js')
        .then(r => r.json())
        .then(cart => update(cart.total_price))

    document.addEventListener('cart:updated', (evt) => {
        update(evt.detail.cart.total_price)
    })
}

document.addEventListener('DOMContentLoaded', freeShippingMessage)
document.addEventListener('shopify:section:load', freeShippingMessage)
// Free shipping message end